import React, { useEffect, useState } from 'react';
import { Button, Form, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import api from '../services/api';

const EditServicePricingModal = ({ isOpen, toggle, pricing = {}, timeframes = [], pricingTiers = [], services = [], onSave }) => {
    const [basePrice, setBasePrice] = useState(pricing ? pricing.base_price : '');
    const [selectedTimeframe, setSelectedTimeframe] = useState(pricing ? pricing.timeframe : '');
    const [selectedPricingTier, setSelectedPricingTier] = useState(pricing ? pricing.pricing_tier : '');
    const [selectedService, setSelectedService] = useState(pricing ? pricing.service : '');

    useEffect(() => {
        if (pricing) {
            setBasePrice(pricing.base_price);
            setSelectedTimeframe(pricing.timeframe);
            setSelectedPricingTier(pricing.pricing_tier);
            setSelectedService(pricing.service);
        }
    }, [pricing]);

    const saveEditedPricing = async () => {
        try {
            const response = await api.put(`/service-pricing/${pricing.id}/`, {
                timeframe: selectedTimeframe,
                pricing_tier: selectedPricingTier,
                service: selectedService,
                base_price: basePrice
            });
            if (onSave) {
                onSave(response.data);
            }
            // Close modal and refresh data or update state if needed
            toggle();
        } catch (error) {
            console.error('Error saving edited service pricing:', error);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Edit Service Pricing</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="timeframe">Timeframe</Label>
                        <Input type="select" name="timeframe" id="timeframe" value={selectedTimeframe} onChange={(e) => setSelectedTimeframe(e.target.value)}>
                            {timeframes.map(t => (
                                <option key={t.id} value={t.id}>{t.name}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="pricingTier">Pricing Tier</Label>
                        <Input type="select" name="pricingTier" id="pricingTier" value={selectedPricingTier} onChange={(e) => setSelectedPricingTier(e.target.value)}>
                            {pricingTiers.map(t => (
                                <option key={t.id} value={t.id}>{t.name}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="service">Service</Label>
                        <Input type="select" name="service" id="service" value={selectedService} onChange={(e) => setSelectedService(e.target.value)}>
                            {services.map(s => (
                                <option key={s.id} value={s.id}>{s.title}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="basePrice">Base Price</Label>
                        <Input type="number" name="basePrice" id="basePrice" step="1.00" value={basePrice} onChange={(e) => setBasePrice(e.target.value)} />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={saveEditedPricing}>Save</Button>{' '}
                <Button color="secondary" onClick={toggle}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
};

export default EditServicePricingModal;
